import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { PostitModel } from '../models/postit.model';
import { Estate } from '../utils/enum.util';

@Injectable()
export class PostitService {

    private antiRebound = 150;
    private timestamp   = 0;
    private _postitList:PostitModel[] = [];

    isOpen = false;

    constructor(public apiService: ApiService) {

    }

    public loadAll(archive:boolean = false){
        this.apiService.get('postits', 'archive=' + archive.toString()).subscribe( (_res)=> {
            if (this._postitList.length)
                this._postitList.length = 0;
            _res.data.forEach((p) => {
                let postit = new PostitModel(this);
                postit.content = p.content;
                postit.privateId = p._id;
                postit.created = p.created;
                postit.updated = p.updated;
                postit.customers = p.clients;
                postit.isArchive = archive;
                postit.contentToScreen();
                this._postitList.push(postit);
            });
            //postitList.push(new PostitModel(this));
        }, (_err) => {
            this.apiService.error(_err);
        });
    }

    public search(postit: PostitModel){
        this.apiService.get('searchClient', 'query=' + postit.search).subscribe(res=> {
            postit.searchResult = res.data.clients;
        }, (_err) => {
            this.apiService.error(_err);
        });
    }

    public delete(postit: PostitModel){
        if (postit.privateId){
            this.apiService.delete('postit', {privateId: postit.privateId}).subscribe((_res)=> {

            }, (_err) => {
                this.apiService.error(_err);
            });
        }
    }

    public unDelete(postit: PostitModel){
        if (postit.privateId){
            this.apiService.delete('postit', {privateId: postit.privateId, unarchive: 'true'}).subscribe((_res)=> {

            }, (_err) => {
                this.apiService.error(_err);
            });
        }
    }

    public create(postit: PostitModel, force:boolean = false) {
        //antiRebounce
        this.timestamp = new Date().getTime();
        setTimeout(()=> {
            if (this.timestamp + this.antiRebound <= new Date().getTime()) {
                this.apiService.post('postit', {content: postit.content}).subscribe(res=> {
                    this.isOpen = false;
                    postit.state     = Estate.Save;
                    postit.customers = res.data.clients;
                    postit.privateId = res.data.privateId;
                    if (force)
                        postit.refresh();
                }, (_err) => {
                    this.apiService.error(_err);
                    postit.state = Estate.Error;
                });
            }
        }, this.antiRebound);
    }

    public update(postit: PostitModel, force:boolean = false) {
        //antiRebounce
        this.timestamp = new Date().getTime();
        setTimeout(()=> {
            if (this.timestamp + this.antiRebound <= new Date().getTime()) {
                this.apiService.put('postit', {content: postit.content, privateId: postit.privateId}).subscribe((res) => {
                    this.isOpen = false;
                    postit.state     = Estate.Save;
                    postit.customers = res.data.clients;
                    if (force)
                        postit.refresh();
                }, (_err) => {
                    this.apiService.error(_err);
                    postit.state = Estate.Error;
                });
            }
        }, this.antiRebound);
    }

    get postitList(): PostitModel[] {
        return this._postitList;
    }

    set postitList(value: PostitModel[]) {
        this._postitList = value;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/services/postit.service.ts